import React, { useMemo, useState } from 'react';
import SidebarProjectList from './SidebarProjectList';
import './ProjectsPanel.css';

const IconClose = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const IconSearch = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const IconPlus = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

/**
 * Sliding "Projects" drawer opened from the sidebar's Projects icon.
 * Floats over the main content (not part of the fixed sidebar layout), so it
 * works the same whether the icon rail is expanded or collapsed.
 */
const ProjectsPanel = ({ isOpen, onClose, projects, onAddProject }) => {
  const [search, setSearch] = useState('');

  const filteredProjects = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return projects;
    return projects.filter((p) => (p.name || '').toLowerCase().includes(q));
  }, [projects, search]);

  return (
    <>
      {isOpen && <div className="projects-panel-backdrop" onClick={onClose} aria-hidden="true" />}
      <div className={`projects-panel ${isOpen ? 'open' : ''}`} role="dialog" aria-modal="true" aria-label="Projects" aria-hidden={!isOpen}>
        <div className="projects-panel-header">
          <h2 className="projects-panel-title">Projects</h2>
          <button
            type="button"
            className="projects-panel-close"
            onClick={onClose}
            aria-label="Close projects panel"
            tabIndex={isOpen ? undefined : -1}
          >
            <IconClose />
          </button>
        </div>

        <div className="projects-panel-search-wrap">
          <span className="projects-panel-search-icon" aria-hidden="true"><IconSearch /></span>
          <input
            type="search"
            className="projects-panel-search-input"
            placeholder="Search projects..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            aria-label="Search projects"
            tabIndex={isOpen ? undefined : -1}
          />
        </div>

        <button
          type="button"
          className="projects-panel-add"
          onClick={onAddProject}
          tabIndex={isOpen ? undefined : -1}
        >
          <IconPlus />
          Add Project
        </button>

        <div className="projects-panel-list-wrap">
          {filteredProjects.length === 0 ? (
            <p className="projects-panel-empty">
              {projects.length === 0 ? 'No projects yet. Click "Add Project" to create one.' : 'No projects match your search.'}
            </p>
          ) : (
            <SidebarProjectList projects={filteredProjects} onItemClick={onClose} />
          )}
        </div>
      </div>
    </>
  );
};

export default ProjectsPanel;
